import { useState } from 'react';
import { faq } from '../../data/faq.js';

export default function FAQ() {
  return (
    <div className="section" id="faq">
      <div style={{ marginBottom: 52 }} data-stagger="80">
        <div className="section-label r">Resolvemos tus dudas</div>
        <h2 className="section-title r">Preguntas frecuentes</h2>
      </div>
      <div className="faq-contact-grid">
        <FaqList />
        <ContactCard />
      </div>
    </div>
  );
}

function FaqList() {
  const [open, setOpen] = useState(null);
  return (
    <div className="faq-list" data-stagger="70">
      {faq.map((item, i) => {
        const isOpen = open === i;
        return (
          <div className={`faq-item r${isOpen ? ' open' : ''}`} key={item.q}>
            <button
              className="faq-trigger"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
            >
              {item.q}
              <span className="faq-icon">+</span>
            </button>
            <div className="faq-body">
              <p>{item.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function ContactCard() {
  const [submitted, setSubmitted] = useState(false);
  function onSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
  }
  return (
    <div className="contact-card r r-right">
      <h3>¿Tienes más dudas?</h3>
      <p>Escríbenos directamente y te respondemos en menos de 24 horas.</p>
      <form
        onSubmit={onSubmit}
        style={submitted ? { opacity: 0.4, pointerEvents: 'none' } : undefined}
      >
        <div className="form-field">
          <input type="text" placeholder="Tu nombre" required />
        </div>
        <div className="form-field">
          <input type="email" placeholder="Email" required />
        </div>
        <div className="form-field">
          <select defaultValue="">
            <option value="" disabled>
              ¿Sobre qué nos escribes?
            </option>
            <option>Información sobre el programa</option>
            <option>Problemas técnicos con Skool</option>
            <option>Colaboraciones</option>
            <option>Otro</option>
          </select>
        </div>
        <div className="form-field">
          <textarea placeholder="Tu mensaje..." />
        </div>
        <button type="submit" className="form-submit">
          Enviar mensaje →
        </button>
      </form>
      {submitted && <div className="form-success-msg">¡Mensaje enviado! Te respondemos pronto.</div>}
    </div>
  );
}
